// Shared with the backend's own rule: `MaterialController::generate` requires
// `chapter_id` OR `instructions` (min 5), never both. In the text flow the
// two are interchangeable regardless of how full the chapter catalogue is —
// a tutor whose topic isn't listed must be able to describe it instead.
export const MIN_INSTRUCTIONS_LENGTH = 5

export const isGenerationFormValid = ({
    useStudyProgram,
    studyProgramChapter,
    schoolClass,
    subject,
    chapter,
    instructions,
}) => {
    // Study-program mode: the program chapter is the scope, nothing else gates.
    if (useStudyProgram) return !!studyProgramChapter
    return !!(
        schoolClass &&
        subject &&
        (chapter || instructions?.length >= MIN_INSTRUCTIONS_LENGTH)
    )
}
